// Import the functions you need from the SDKs you need
import { initializeApp , getApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getStorage } from "firebase/storage";
import {getDatabase} from 'firebase/database'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// rules_version = '2';
// service firebase.storage {
//   match /b/{bucket}/o {
//     match /{allPaths=**} {
//       allow read, write: if true;
//     }
//   }
// }


const firebaseConfig = {
  apiKey: "AIzaSyDt5C9DaJDrKpCcB3jJlFsxWyPCHxCzV7Q",
  authDomain: "eatprotein-1d655.firebaseapp.com",
  projectId: "eatprotein-1d655",
  storageBucket: "eatprotein-1d655.firebasestorage.app",
  messagingSenderId: "904002596950",
  appId: "1:904002596950:web:705b26dca64050a72ccbf7",
  measurementId: "G-5QQJR074TQ"
};



// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const analytics = getAnalytics(app);
const storage = getStorage(app);
export const database = getDatabase(app);
export { storage };

// const mesg=getMessaging();